import { domains, type PrivateDomainPath, privateDomainPaths } from '@config'

export const usePrivateDomainPath = (pathId: PrivateDomainPath) => {
  const path = privateDomainPaths[pathId]
  return `${domains.private.production}${path}`
}
